import { BASE_URL } from '@/utils/Constants';
import { useAuth } from '@/utils/stores/useAuthStore';
import { useMutation } from '@tanstack/react-query';

const downloadDocument = async (id: string, token: string) => {
  const response = await fetch(`${BASE_URL}/api/documents/${id}/download`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error('Failed to download document');
  }
  const data = await response.json();
  return data;
};

export const useDownloadDocument = (id: string) => {
  const { idToken } = useAuth();
  const { mutate, isPending, error, isSuccess, data } = useMutation({
    mutationFn: () => downloadDocument(id, idToken!),
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (error) => {
      console.error(error);
    },
  });
  return { mutate, isPending, error, isSuccess, data };
};
